<nav class="fixed top-0 z-[1000] w-full bg-white border-b border-gray-400 px-4 py-3 lg:px-5">

  <div class="flex items-center justify-between">

    <div class="flex items-center gap-2">
      <button type="button"
        class="text-gray-700 bg-transparent hover:bg-gray-200 focus:ring-2 focus:ring-gray-300 font-medium rounded-lg p-2 inline-flex sm:hidden"
        (click)="toggleSidebar()">
        <span class="sr-only">Open sidebar</span>
        <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M5 7h14M5 12h14M5 17h10" />
        </svg>
      </button>

      <a class="flex items-center" href="#">
        <img src="assets/images/logo.svg" class="h-[30px] sm:h-[35px]" alt="LOGO" />
      </a>
    </div>

    <div class="flex items-center gap-3 sm:gap-4">

      <div class="flex items-center">
        @if (!walletAddress) {
        <button type="button" (click)="connectWallet()"
          class="bg-primary py-1.5 px-3 sm:px-4 rounded-[10px] text-white font-medium text-xs sm:text-sm hover:bg-blue cursor-pointer">
          Connect Wallet
        </button>
        } @else {
        <div
          class="px-3 py-1.5 text-xs sm:text-sm text-gray-700 border border-gray-300 rounded-[10px] bg-gray-50 whitespace-nowrap font-mono">
          {{ walletAddress | slice:0:6 }}...{{ walletAddress | slice:-4 }}
        </div>
        }
      </div>
      <!-- <div class="flex items-center gap-2">
        <div class="relative w-8 h-8 overflow-hidden bg-neutral-secondary-medium rounded-full">
          <svg class="absolute w-10 h-10 text-body-subtle -left-1" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd">
            </path>
          </svg>
        </div>
        <span class="text-sm font-medium">Admin</span>
      </div> -->

      <button type="button" (click)="openLogoutModal($event)"
        class="bg-primary py-1.5 px-3 sm:px-4 rounded-[10px] text-white font-medium text-xs sm:text-sm hover:bg-blue cursor-pointer">
        Logout
      </button>
    </div>

  </div>
</nav>


<aside id="default-sidebar"
  class="fixed top-[60px] left-0 z-[999] w-64 h-[calc(100%-60px)] transition-transform transform bg-white border-r border-gray-300"
  [ngClass]="{'-translate-x-full': !isSidebarOpen, 'translate-x-0': isSidebarOpen}">
  <div class="overflow-y-auto p-3 sm:p-4 md:p-5 h-full bg-white custom-modal">
    <ul class="flex flex-col gap-2 lg:gap-3 w-full">
      <!-- <li>
        <a [routerLink]="['/dashboard']" routerLinkActive="bg-blue-100 text-black font-semibold"
          [routerLinkActiveOptions]="{ exact: true }"
          class="flex items-center gap-2 lg:gap-3 px-2 py-3 rounded-[10px] font-normal text-sm text-primary hover:text-primary group hover:bg-blue/10">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"
            class="stroke-current text-primary group-[.active]:text-blue">
            <path
              d="M13.6903 19.9567C13.5 19.4973 13.5 18.9149 13.5 17.75C13.5 16.5851 13.5 16.0027 13.6903 15.5433C13.944 14.9307 14.4307 14.444 15.0433 14.1903C15.5027 14 16.0851 14 17.25 14C18.4149 14 18.9973 14 19.4567 14.1903C20.0693 14.444 20.556 14.9307 20.8097 15.5433C21 16.0027 21 16.5851 21 17.75C21 18.9149 21 19.4973 20.8097 19.9567C20.556 20.5693 20.0693 21.056 19.4567 21.3097C18.9973 21.5 18.4149 21.5 17.25 21.5C16.0851 21.5 15.5027 21.5 15.0433 21.3097C14.4307 21.056 13.944 20.5693 13.6903 19.9567Z"
              stroke="currentColor" stroke-opacity="1" stroke-width="1.5" stroke-linecap="square"
              stroke-linejoin="round" />
            <path
              d="M13.6903 9.45671C13.5 8.99728 13.5 8.41485 13.5 7.25C13.5 6.08515 13.5 5.50272 13.6903 5.04329C13.944 4.43072 14.4307 3.94404 15.0433 3.6903C15.5027 3.5 16.0851 3.5 17.25 3.5C18.4149 3.5 18.9973 3.5 19.4567 3.6903C20.0693 3.94404 20.556 4.43072 20.8097 5.04329C21 5.50272 21 6.08515 21 7.25C21 8.41485 21 8.99728 20.8097 9.45671C20.556 10.0693 20.0693 10.556 19.4567 10.8097C18.9973 11 18.4149 11 17.25 11C16.0851 11 15.5027 11 15.0433 10.8097C14.4307 10.556 13.944 10.0693 13.6903 9.45671Z"
              stroke="currentColor" stroke-opacity="1" stroke-width="1.5" stroke-linecap="square"
              stroke-linejoin="round" />
            <path
              d="M3.1903 19.9567C3 19.4973 3 18.9149 3 17.75C3 16.5851 3 16.0027 3.1903 15.5433C3.44404 14.9307 3.93072 14.444 4.54329 14.1903C5.00272 14 5.58515 14 6.75 14C7.91485 14 8.49728 14 8.95671 14.1903C9.56928 14.444 10.056 14.9307 10.3097 15.5433C10.5 16.0027 10.5 16.5851 10.5 17.75C10.5 18.9149 10.5 19.4973 10.3097 19.9567C10.056 20.5693 9.56928 21.056 8.95671 21.3097C8.49728 21.5 7.91485 21.5 6.75 21.5C5.58515 21.5 5.00272 21.5 4.54329 21.3097C3.93072 21.056 3.44404 20.5693 3.1903 19.9567Z"
              stroke="currentColor" stroke-opacity="1" stroke-width="1.5" stroke-linecap="square"
              stroke-linejoin="round" />
            <path
              d="M3.1903 9.45671C3 8.99728 3 8.41485 3 7.25C3 6.08515 3 5.50272 3.1903 5.04329C3.44404 4.43072 3.93072 3.94404 4.54329 3.6903C5.00272 3.5 5.58515 3.5 6.75 3.5C7.91485 3.5 8.49728 3.5 8.95671 3.6903C9.56928 3.94404 10.056 4.43072 10.3097 5.04329C10.5 5.50272 10.5 6.08515 10.5 7.25C10.5 8.41485 10.5 8.99728 10.3097 9.45671C10.056 10.0693 9.56928 10.556 8.95671 10.8097C8.49728 11 7.91485 11 6.75 11C5.58515 11 5.00272 11 4.54329 10.8097C3.93072 10.556 3.44404 10.0693 3.1903 9.45671Z"
              stroke="currentColor" stroke-opacity="1" stroke-width="1.5" stroke-linecap="square"
              stroke-linejoin="round" />
          </svg>
          <span>Dashboard</span>
        </a>
      </li> -->

      <li>
        <a [routerLink]="['/usermanagement']"
          [ngClass]="{'bg-blue-100 text-black font-semibold': isActive(['usermanagement', 'viewusermanagement'])}"
          class="flex items-center gap-2 lg:gap-3 px-2 py-3 rounded-[10px] font-normal text-sm text-primary hover:text-primary group hover:bg-blue/10">
          <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            fill="none" viewBox="0 0 18 20">
            <path stroke="currentColor" stroke-opacity="1" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="1.5"
              d="M4 4H1m3 4H1m3 4H1m3 4H1m6.071.286a3.429 3.429 0 1 1 6.858 0M4 1h12a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1Zm9 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" />
          </svg>
          <span>User Management</span>
        </a>
      </li>

      <li>
        <a [routerLink]="['/categorymanagement']"
          [ngClass]="{'bg-blue-100 text-black font-semibold': isActive(['categorymanagement', 'add-category-management', 'edit-category-management'])}"
          class="flex items-center gap-2 lg:gap-3 px-2 py-3 rounded-[10px] font-normal text-sm text-primary hover:text-primary group hover:bg-blue/10">
          <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-opacity="1" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="1.5"
              d="M15.583 8.445h.01M10.86 19.71l-6.573-6.63a.993.993 0 0 1 0-1.4l7.329-7.394A.98.98 0 0 1 12.31 4l5.734.007A1.968 1.968 0 0 1 20 5.983v5.5a.992.992 0 0 1-.316.727l-7.44 7.5a.974.974 0 0 1-1.384.001Z" />
          </svg>

          <span>Category Management</span>
        </a>
      </li>

      <li>
        <a [routerLink]="['/marketmanagement']"
          [ngClass]="{'bg-blue-100 text-black font-semibold': isActive(['marketmanagement', 'addmarket', 'editmarket'])}"
          class="flex items-center gap-2 lg:gap-3 px-2 py-3 rounded-[10px] font-normal text-sm text-primary hover:text-primary group hover:bg-blue/10">
          <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-opacity="1" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="1.5"
              d="M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-6 5h6m-6 4h6M10 3v4h4V3h-4Z" />
          </svg>

          <span>Market Management</span>
        </a>
      </li>

      <!-- <li>
        <a [routerLink]="['/marketapprovalmanagement']" routerLinkActive="bg-blue-100 text-black font-semibold"
          [routerLinkActiveOptions]="{ exact: true }"
          class="flex items-center gap-2 lg:gap-3 px-2 py-3 rounded-[10px] font-normal text-sm text-primary hover:text-primary group hover:bg-blue/10">
          <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-opacity="1" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="1.5" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>

          <span>Market Approval Management</span>
        </a>
      </li>

      <li>
        <a [routerLink]="['/rejectedmarkets']" routerLinkActive="bg-blue-100 text-black font-semibold"
          [routerLinkActiveOptions]="{ exact: true }"
          class="flex items-center gap-2 lg:gap-3 px-2 py-3 rounded-[10px] font-normal text-sm text-primary hover:text-primary group hover:bg-blue/10">
          <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-opacity="1" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="1.5" d="m15 9-6 6m0-6 6 6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>

          <span>Rejected Markets</span>
        </a>
      </li>

      <li>
        <a [routerLink]="['/settings']" routerLinkActive="bg-blue-100 text-black font-semibold"
          [routerLinkActiveOptions]="{ exact: true }"
          class="flex items-center gap-2 lg:gap-3 px-2 py-3 rounded-[10px] font-normal text-sm text-primary hover:text-primary group hover:bg-blue/10">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none"
            class="text-primary group-[.active]:text-blue">
            <path
              d="M14.25 10.061C14.25 11.994 12.683 13.561 10.75 13.561C8.817 13.561 7.25 11.994 7.25 10.061C7.25 8.12804 8.817 6.56104 10.75 6.56104C12.683 6.56104 14.25 8.12804 14.25 10.061Z"
              stroke="currentColor" stroke-opacity="1" stroke-width="1.5" />
            <path
              d="M19.761 12.1574C20.2829 12.0167 20.5439 11.9463 20.6469 11.8117C20.75 11.6772 20.75 11.4607 20.75 11.0278V9.09406C20.75 8.66116 20.75 8.44466 20.6469 8.31016C20.5438 8.17556 20.2829 8.10516 19.761 7.96444C17.8106 7.43845 16.5899 5.39937 17.0933 3.46173C17.2317 2.92885 17.3009 2.66242 17.2348 2.50615C17.1687 2.34988 16.9791 2.2422 16.5997 2.02682L14.875 1.04759C14.5028 0.836248 14.3167 0.730578 14.1497 0.753078C13.9826 0.775578 13.7942 0.963588 13.4172 1.33959C11.958 2.79534 9.5436 2.79528 8.08434 1.3395C7.70743 0.963488 7.51898 0.775488 7.35193 0.752978C7.18489 0.730478 6.99877 0.836148 6.62653 1.04749L4.90184 2.02673C4.52253 2.24209 4.33287 2.34977 4.26678 2.50601C4.20068 2.66226 4.26987 2.92873 4.40825 3.46166C4.91137 5.39936 3.68972 7.43849 1.73902 7.96446C1.21712 8.10516 0.95617 8.17556 0.85308 8.31006C0.75 8.44466 0.75 8.66116 0.75 9.09406V11.0278C0.75 11.4607 0.75 11.6772 0.85308 11.8117C0.95615 11.9463 1.21711 12.0167 1.73902 12.1574C3.6894 12.6834 4.91008 14.7225 4.40672 16.6601C4.26829 17.193 4.19907 17.4594 4.26516 17.6157C4.33126 17.772 4.52092 17.8797 4.90025 18.095L6.62495 19.0743C6.99721 19.2856 7.18334 19.3913 7.3504 19.3688C7.51746 19.3463 7.70588 19.1582 8.08271 18.7822C9.5427 17.3253 11.9588 17.3252 13.4189 18.7821C13.7957 19.1582 13.9841 19.3462 14.1512 19.3687C14.3182 19.3912 14.5044 19.2855 14.8766 19.0742L16.6013 18.0949C16.9807 17.8796 17.1704 17.7719 17.2364 17.6156C17.3025 17.4593 17.2333 17.1929 17.0948 16.66C16.5912 14.7225 17.8109 12.6835 19.761 12.1574Z"
              stroke="currentColor" stroke-opacity="1" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <span>Settings</span>
        </a>
      </li> -->

    </ul>
  </div>
</aside>
@if (isSidebarOpen) {
<div class="fixed inset-0 z-30 bg-black opacity-50 sm:hidden" (click)="closeSidebar()"></div>
}


<!-- Logout Confirmation Modal -->
@if (showLogoutModal) {
<!-- Backdrop -->
<div class="fixed inset-0 bg-black/50 z-[1001]"></div>

<!-- Modal -->
<div
    class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg z-[1002] w-80 p-5">
    <h3 class="text-lg font-semibold mb-3 cursor-pointer">Logout</h3>
    <p class="mb-5 text-sm">Are you sure you want to logout?</p>

    <div class="flex justify-end gap-3">

        <button type="button" (click)="closeLogoutModal()"
            class="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300">
            No
        </button>

        <button type="button" (click)="onLogout()" class="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
            Yes
        </button>

    </div>
</div>
}